export default __webpack_public_path__ + "static/media/early-f.6980393d.svg";